import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  Container,
  Row,
  Col,
  Card,
  Dropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  BsFunnelFill,
  BsSearch,
  BsArrowClockwise,
  BsThreeDotsVertical,
  BsPencilFill,
  BsTrashFill,
  BsBookFill} from 'react-icons/bs'
import {
  LuGraduationCap} from 'react-icons/lu'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditSubjectModal from './EditSubjectModal'
import Cookies from 'js-cookie'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-typeahead'
import { Typeahead } from 'react-bootstrap-typeahead'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'

const AddSubject = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedClass, setSelectedClass] = useState(null)
  const [selectedData, setSelectedData] = useState({})

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])

  useEffect(() => {
    const userLogged = Cookies.get('user')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        setUserRole(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const initialData = []

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [courses, setCourses] = useState([])
  const [allCourses, setAllCourses] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    class: ''})
  const [allSubjects, setAllSubjects] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((response) => {
        console.log(response.data)
        // setData(response.data.data) // Current view (filtered/unfiltered)
        setAllCourses(response.data.data) // Full master list
        setCourses(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [])
  const handleCourseChange = (e) => {
    const courseId = e.target.value
    const updatedFilters = { ...selectedFilters, course: courseId }
    setSelectedFilters(updatedFilters)
    handleSelect(updatedFilters)
  }

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)
    console.log('SETSELECTEDDATA:', selectedValues)
    fetchFilteredData(selectedValues)
  }

  // const fetchFilteredData = (selectedValues) => {
  //   const { course } = selectedValues
  //   let updatedData = allSubjects // <- this should be classes, not courses
  //   console.log('updatedData', updatedData)
  //   if (course) {
  //     updatedData = updatedData.filter(
  //       (item) => item.course_id?.toString() === course.toString(),
  //     )
  //   }

  //   setData(updatedData)
  // }
  const fetchFilteredData = (selectedValues, subjectsSource = allSubjects) => {
    const { course } = selectedValues || {}

    // If no course filter, show all subjects
    if (!course) {
      setData(subjectsSource)
      return
    }

    // Filter by course
    const updatedData = subjectsSource.filter(
      (item) => item.course_id?.toString() === course.toString(),
    )

    setData(updatedData)
  }

  useEffect(() => {
    ApiEndpoints.getAllSubjects()
      .then((response) => {
        console.log(response.data.data)
        const subjects = response.data.data || []
        setAllSubjects(subjects)
        // Apply current filter if any
        fetchFilteredData(selectedData)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
        setAllSubjects([])
        setData([])
      })
  }, [])

  useEffect(() => {
    // When selectedData changes, apply filter
    if (allSubjects.length > 0) {
      fetchFilteredData(selectedData)
    }
  }, [selectedData, allSubjects])

  const handleRefresh = async () => {
    try {
      const response = await ApiEndpoints.getAllSubjects()
      const subjects = response.data.data || []
      setAllSubjects(subjects)
      setData(subjects)
      setSelectedFilters({ course: '' })
      setSelectedData({})
      setSearch('')
      setCurrentPage(1)
    } catch (error) {
      toast.error('Failed to refresh data.')
    }
  }

  // Used after editing a subject so the list updates immediately
  const refreshSubjectsAfterEdit = async () => {
    try {
      const response = await ApiEndpoints.getAllSubjects()
      const subjects = response.data.data || []
      setAllSubjects(subjects)

      // Apply the current filters/search state without resetting them
      fetchFilteredData(selectedData, subjects)
      setCurrentPage(1)
    } catch (error) {
      toast.error('Failed to refresh data.')
    }
  }
  const emptySubjectField = () => ({
    subject_name: '',
    is_theory: 1,
    is_practical: 0,
  })

  const [newSubject, setNewSubject] = useState({
    subject_names: [emptySubjectField()],
    course_id: ''})

  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target
  //   console.log(
  //     `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
  //   )
  //   setNewSubject((prev) => ({ ...prev, [name]: value }))
  // }

  const handleInputChange = (e, index = null) => {
    const { name, value } = e.target

    if (name === 'course_id') {
      setNewSubject((prev) => ({ ...prev, course_id: value }))
    } else if (name === 'subject_name') {
      setNewSubject((prev) => {
        const updatedSubjects = [...prev.subject_names]
        updatedSubjects[index] = {
          ...updatedSubjects[index],
          subject_name: value,
        }
        return { ...prev, subject_names: updatedSubjects }
      })
    }
  }

  const handleSubjectTypeChange = (index, field, checked) => {
    setNewSubject((prev) => {
      const updatedSubjects = [...prev.subject_names]
      updatedSubjects[index] = {
        ...updatedSubjects[index],
        [field]: checked ? 1 : 0,
      }
      return { ...prev, subject_names: updatedSubjects }
    })
  }

  const handleAddSubjectField = () => {
    setNewSubject((prev) => ({
      ...prev,
      subject_names: [...prev.subject_names, emptySubjectField()]}))
  }

  const handleRemoveSubjectField = (index) => {
    setNewSubject((prev) => {
      const updatedSubjects = [...prev.subject_names]
      updatedSubjects.splice(index, 1)
      return { ...prev, subject_names: updatedSubjects }
    })
  }

  const handleSave = async () => {
    try {
      if (!newSubject.course_id) {
        toast.error('Please select a course.')
        return
      }
      const payload = {
        course_id: newSubject.course_id,
        subjects: newSubject.subject_names
          .filter((item) => item.subject_name.trim() !== '')
          .map((item) => ({
            subject_name: item.subject_name.trim(),
            is_theory: item.is_theory ? 1 : 0,
            is_practical: item.is_practical ? 1 : 0,
          }))}

      if (payload.subjects.length === 0) {
        toast.error('Please enter at least one subject name.')
        return
      }
      console.log('Sending data: ', payload)
      const response = await ApiEndpoints.addSubject(payload)
      const resultText = (response.data?.result || '').toString()
      const errorMessage = response.data?.message

      // API may return HTTP 200 with { result: "Error occurred", message: "..." }
      if (/error/i.test(resultText)) {
        toast.error(
          errorMessage || resultText || 'Failed to add subject.',
        )
        return
      }

      const listResponse = await ApiEndpoints.getAllSubjects()
      const subjects = listResponse.data.data || []
      setAllSubjects(subjects)
      setCurrentPage(1)

      // Reset the form after submission
      setNewSubject({
        subject_names: [emptySubjectField()],
        course_id: ''})
      setShowModal(false)

      toast.success(errorMessage || resultText || 'Subject added successfully.')
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.result ||
          'Failed to add subject.',
      )
    }
  }
  const handleDeleteSubject = async () => {
    if (!selectedClass) return

    try {
      const response = await ApiEndpoints.deleteSubject(selectedClass.id)
      const resultText = (response.data?.result || '').toString()

      if (/error/i.test(resultText)) {
        toast.error(
          response.data?.message || resultText || 'Failed to delete subject.',
        )
        return
      }

      toast.success(resultText || 'Subject deleted successfully.')
      setShowDeleteModal(false)
      setSelectedClass(null)
      await refreshSubjectsAfterEdit()
    } catch (error) {
      const errorData = error.response?.data
      const status = error.response?.status

      if (status === 409 && Array.isArray(errorData?.reasons) && errorData.reasons.length > 0) {
        errorData.reasons.forEach((reason) => toast.error(reason))
        return
      }

      toast.error(
        errorData?.message ||
          errorData?.result ||
          (status === 403
            ? 'You do not have permission to delete subjects.'
            : 'Failed to delete subject.'),
      )
    }
  }

  const canDeleteSubject = (() => {
    const userType = (user?.user_type || '').toLowerCase()
    const roles = (userRole?.roles || []).map((role) => String(role).toLowerCase())
    return (
      userType === 'admin' ||
      userType === 'superadmin' ||
      roles.includes('admin') ||
      roles.includes('superadmin')
    )
  })()

  const getSubjectTypeLabel = (item) => {
    const isTheory =
      item?.is_theory === true || item?.is_theory === 1 || item?.is_theory === '1'
    const isPractical =
      item?.is_practical === true ||
      item?.is_practical === 1 ||
      item?.is_practical === '1'

    if (isTheory && isPractical) return 'Theory, Practical'
    if (isTheory) return 'Theory'
    if (isPractical) return 'Practical'
    return '—'
  }

  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
          
          /* Prevent horizontal scrolling */
          body {
            overflow-x: hidden !important;
          }
          
          /* Ensure pagination doesn't cause overflow */
          .pagination {
            overflow-x: auto !important;
            overflow-y: hidden !important;
            -webkit-overflow-scrolling: touch !important;
          }
          
          .pagination::-webkit-scrollbar {
            height: 4px;
          }
          
          .pagination::-webkit-scrollbar-track {
            background: #F3F4F6;
            border-radius: 2px;
          }
          
          .pagination::-webkit-scrollbar-thumb {
            background: #D1D3D4;
            border-radius: 2px;
          }
          
          .pagination::-webkit-scrollbar-thumb:hover {
            background: #9ca3af;
          }
          
          /* Fix Typeahead dropdown visibility - ensure it appears above filter card */
          .add-subject-modal .modal-content,
          .add-subject-modal .modal-body,
          .edit-subject-modal .modal-content,
          .edit-subject-modal .modal-body {
            overflow: visible !important;
          }

          .modal .rbt-menu {
            z-index: 1060 !important;
          }

          .rbt-menu {
            z-index: 1051 !important;
            max-height: 300px !important;
            overflow-y: auto !important;
            position: absolute !important;
            width: 100% !important;
            background-color: #ffffff !important;
            border: 1px solid #D1D3D4 !important;
            border-radius: 8px !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
            margin-top: 4px !important;
          }
          
          .rbt-input-wrapper {
            position: relative !important;
            z-index: 1 !important;
          }
          
          .rbt-input-main {
            border-radius: 8px !important;
            border: 1px solid #D1D3D4 !important;
            font-size: 14px !important;
            padding: 8px 12px !important;
            transition: all 0.2s ease !important;
            font-family: 'Inter', system-ui, sans-serif !important;
          }
          
          .rbt-input-main:focus {
            border-color: #223843 !important;
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
          }
          
          .rbt-menu .dropdown-item {
            padding: 10px 12px !important;
            font-size: 14px !important;
            font-family: 'Inter', system-ui, sans-serif !important;
            color: #111827 !important;
            cursor: pointer !important;
          }
          
          .rbt-menu .dropdown-item:hover,
          .rbt-menu .dropdown-item.active {
            background-color: #F3F4F6 !important;
            color: #111827 !important;
          }
          
          /* Ensure filter card container allows dropdown to overflow */
          .filter-card-container {
            overflow: visible !important;
            position: relative !important;
            z-index: 10 !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Subject Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Manage Subjects
              </h3>
              {/* {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                <button
                  onClick={() => setShowModal(true)}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#223843',
                    border: 'none',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title="Add New Subject"
                >
                  <BsBookFill size={20} />
                </button>
              )} */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            // paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
            overflowX: 'hidden',
            maxWidth: '100%'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '120px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>

            {/* Add New — desktop (mobile below, match CreateAnnouncement.js) */}
            {/* {(user?.user_type === 'admin' || userRole?.roles?.includes("admin") ||) && ( */}
            {(user?.user_type === 'admin' || user?.user_type === 'staff' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("staff") || userRole?.roles?.includes("teacher")) && (
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Subject"
              >
                <BsBookFill size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Subject
                </span>
              </button>
            )}
          </div>

          {/* {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && ( */}
                          {(user?.user_type === 'admin' || user?.user_type === 'staff' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("staff") || userRole?.roles?.includes("teacher")) && (
            <div className="d-md-none d-flex justify-content-end mb-4">
              <button
                type="button"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Subject"
              >
                <BsBookFill size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Subject
                </span>
              </button>
            </div>
          )}

          {/* Modern Filter Section */}
          <div 
            className="filter-card-container"
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: showFilterCard ? 'visible' : 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0',
              position: 'relative',
              zIndex: showFilterCard ? 10 : 1}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'visible',
                  position: 'relative'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search & Filter Subjects
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find subjects quickly with advanced filters
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                  <Row className="g-4 text-start">
                    {/* Filter by Course */}
                    <Col xs={12}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative'}}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'}}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Filter by Course
                          </label>
                        </div>
                        <Row className="g-3">
                          {/* Course Selector */}
                          <Col xs={12}>
                            <div style={{ position: 'relative', zIndex: 1050 }}>
                              <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Select Course
                              </label>
                              <div style={{ position: 'relative', zIndex: 1050 }}>
                                <Typeahead
                                  id="course-select"
                                  labelKey="name"
                                  onChange={(selected) => {
                                    const course = selected[0]
                                    if (course) {
                                      handleCourseChange({ target: { value: course.id } })
                                    } else {
                                      handleCourseChange({ target: { value: '' } })
                                    }
                                  }}
                                  options={courses}
                                  placeholder="Select Course"
                                  selected={selectedFilters.course ? courses.filter(
                                    (cour) => cour.id === Number(selectedFilters.course),
                                  ) : []}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Subject Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Course</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Subject Type</Th>
                {/* {user?.user_type !== 'teacher' && (
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
                )} */}
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>


              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#F3F4F6',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #D1D3D4'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#F3F4F6'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#F3F4F6'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.subject_name}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {courses.find((course) => course.id === item.course_id)?.name || 'N/A'}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {getSubjectTypeLabel(item)}
                    </Td>
                    {/* {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && ( */}
                                    {(user?.user_type === 'admin' || user?.user_type === 'staff' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("staff") || userRole?.roles?.includes("teacher")) && (
                      <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                        {/* Desktop View - Dropdown */}
                        <div className="d-none d-md-block">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id={`dropdown-${item.id}`}
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                border: '1px solid #D1D3D4',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease'}}
                              className="dropdown-toggle-no-caret"
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.borderColor = '#223843'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.borderColor = '#D1D3D4'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsThreeDotsVertical style={{ color: 'inherit' }} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                padding: '8px',
                                minWidth: '180px'}}
                            >
                              <Dropdown.Item
                                onClick={() => {
                                  setSelectedClass(item)
                                  setShowEditModal(true)
                                }}
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsPencilFill size={18} /> Edit Subject
                              </Dropdown.Item>
                              {canDeleteSubject && (
                              <Dropdown.Item
                                onClick={() => {
                                  setSelectedClass(item)
                                  setShowDeleteModal(true)
                                }}
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#EF4444'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsTrashFill size={18} /> Delete Subject
                              </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        {/* Mobile View - Circular Buttons */}
                        <div className="d-md-none d-flex justify-content-start gap-2">
                          <button
                            onClick={() => {
                              setSelectedClass(item)
                              setShowEditModal(true)
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#059669'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#10B981'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Edit Subject"
                          >
                            <BsPencilFill size={16} />
                          </button>
                          {canDeleteSubject && (
                          <button
                            onClick={() => {
                              setSelectedClass(item)
                              setShowDeleteModal(true)
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#EF4444',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#DC2626'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#EF4444'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Delete Subject"
                          >
                            <BsTrashFill size={16} />
                          </button>
                          )}
                        </div>
                      </Td>
                    )}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={user?.user_type !== 'teacher' ? "4" : "3"} className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Card>

        <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="subjects"
          maxVisiblePages={isMobile ? 5 : 7}
          paginationScrollable
        />
        </div>

      {/* Add New Class Modal */}
      <Modal
        className="add-subject-modal"
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
          <Modal.Title>Add New Subject</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <div style={{ position: 'relative' }}>
              <Typeahead
                id="add-subject-course"
                labelKey="name"
                onChange={(selected) => {
                  const course = selected[0]
                  handleInputChange({
                    target: {
                      name: 'course_id',
                      value: course ? course.id : '',
                    },
                  })
                }}
                options={courses}
                placeholder="Select Course"
                positionFixed
                selected={
                  newSubject.course_id
                    ? courses.filter(
                        (course) =>
                          String(course.id) === String(newSubject.course_id),
                      )
                    : []
                }
                inputProps={{
                  required: true,
                  style: {
                    borderRadius: '8px',
                    border: '1px solid #D1D3D4',
                    fontSize: '14px',
                    minHeight: '38px',
                  },
                }}
              />
            </div>
          </Form.Group>
          <Form>
            {/* Class Name Field */}

            {newSubject.subject_names.map((subject, index) => (
              <div key={index} className="mb-3">
                <div className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    name="subject_name"
                    value={subject.subject_name}
                    onChange={(e) => handleInputChange(e, index)}
                    placeholder={`Subject Name ${index + 1}`}
                    className="p-2 border rounded me-2"
                  />
                  {newSubject.subject_names.length > 1 && (
                    <Button
                      variant="danger"
                      onClick={() => handleRemoveSubjectField(index)}
                    >
                      &times;
                    </Button>
                  )}
                </div>
                <div className="d-flex gap-4 mt-2">
                  <Form.Check
                    type="checkbox"
                    id={`subject-theory-${index}`}
                    label="Theory"
                    checked={subject.is_theory === 1}
                    onChange={(e) =>
                      handleSubjectTypeChange(index, 'is_theory', e.target.checked)
                    }
                  />
                  <Form.Check
                    type="checkbox"
                    id={`subject-practical-${index}`}
                    label="Practical"
                    checked={subject.is_practical === 1}
                    onChange={(e) =>
                      handleSubjectTypeChange(
                        index,
                        'is_practical',
                        e.target.checked,
                      )
                    }
                  />
                </div>
              </div>
            ))}
            <Button variant="secondary" onClick={handleAddSubjectField}>
              + Add Another Subject
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            className="rounded-pill px-4"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="rounded-pill px-4"
            onClick={handleSave}
          >
            Save Subject
          </Button>
        </Modal.Footer>
      </Modal>
      <EditSubjectModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        subject={selectedClass}
        onSubjectUpdated={refreshSubjectsAfterEdit}
      />
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered size="lg">
        <Modal.Header closeButton closeVariant="white" className="bg-danger text-white">
          <Modal.Title>Delete Subject</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2 fw-semibold" style={{ letterSpacing: '2px' }}>
            Are you sure you want to delete the subject <strong>{selectedClass?.subject_name}</strong>?
            <hr />
            <div className="mt-3 text-muted fw-semibold" style={{ letterSpacing: '2px' }}>
              This action is irreversible and the subject will be permanently removed.
            </div>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteSubject}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </>
  )
}

export default AddSubject
